//Authentication
export const POST_LOGIN = "/api/Authentication/Login";
export const POST_RefreshToken = "/api/Authentication/RefreshToken";
export const POST_RevokeToken = "/api/Authentication/RevokeToken";
export const POST_HealthCheck = "/api/Authentication/HealthCheck";
export const POST_Logout = "/api/Authentication/LogoutUser";
export const POST_ForgotPassword = "/api/Authentication/ForgotPassword";
export const POST_ValidateForgotPasswordLink =
  "/api/Authentication/ValidateForgotPasswordLink";
export const POST_ResetPassword = "/api/Authentication/ResetPassword";
export const POST_ChangePassword = "/api/Common/ChangePassword";

export const POST_CompanyDetailByID = "/api/Authentication/CompanyDetailByID";
export const POST_CompanyDetailForChekLoginURL =
  "/api/Authentication/CompanyDetailForChekLoginURL";

//Common
export const POST_RoleDDLList = "/api/Common/GetRoleListByCompanyID";
export const POST_BranchDDLList = "/api/Common/GetBranchDropDownList";
export const POST_ValidateLicenseLimit = "/api/Common/ValidateLicenseLimit";

//Voucher Series
export const POST_VoucherSeriesTransactionTypeList =
  "/api/VoucherSeries/GetVoucherSeriesTranTypeList";
export const POST_GetVoucherSeriesList =
  "/api/VoucherSeries/GetVoucherSeriesList";
export const POST_GetVoucherSeriesDetailByID =
  "/api/VoucherSeries/GetVoucherSeriesDetailByID";
export const POST_VoucherSeriesActiveInActive =
  "/api/VoucherSeries/VoucherSeriesActiveInActive";
export const POST_VoucherSeriesDelete =
  "/api/VoucherSeries/VoucherSeriesDelete";
export const POST_VoucherSeriesInsert =
  "/api/VoucherSeries/VoucherSeriesInsert";
export const POST_VoucherSeriesUpdate =
  "/api/VoucherSeries/VoucherSeriesUpdate";
export const POST_VoucherSeriesExport =
  "/api/VoucherSeries/VoucherSeriesExport";

//Categories
export const GET_CategoryTypes = "/api/Category/GetCategoryTypes";
export const POST_GetCategoryListByCategoryType =
  "/api/Category/GetCategoryListByCategoryType";
export const POST_GetCategoryByID = "/api/Category/GetCategoryByID";
export const POST_CategoryInsert = "/api/Category/CategoryInsert";
export const POST_CategoryUpdate = "/api/Category/CategoryUpdate";
export const POST_CategoryStatusUpdate = "/api/Category/CategoryStatusUpdate";
export const POST_CategoryDelete = "/api/Category/CategoryDelete";
export const POST_CategoryExport = "/api/Category/CategoryExport";
export const POST_GetCategoryDropDownListByCategoryType =
  "/api/Category/GetCategoryDropDownListByCategoryType";

//Application Setup
export const POST_GetApplicationSetupByCompanyID =
  "/api/ApplicationConfiguration/GetApplicationConfigurationByCompanyID";
export const POST_EmailConfigurationInsert =
  "/api/ApplicationConfiguration/EmailConfigurationInsert";
export const POST_EmailConfigurationUpdate =
  "/api/ApplicationConfiguration/EmailConfigurationUpdate";
export const POST_EmailSettingsVerification =
  "/api/ApplicationConfiguration/VerifyEmailSettings";
export const POST_NotificationConfigurationInsert =
  "/api/ApplicationConfiguration/NotificationConfigurationInsert";
export const POST_NotificationConfigurationUpdate =
  "/api/ApplicationConfiguration/NotificationConfigurationUpdate";
export const POST_SentenceConfigurationInsert =
  "/api/ApplicationConfiguration/SentenceConfigurationInsert";
export const POST_SentenceConfigurationUpdate =
  "/api/ApplicationConfiguration/SentenceConfigurationUpdate";
export const POST_EInvoiceConfigurationSave =
  "/api/ApplicationConfiguration/EInvoiceConfigurationSave";
export const POST_WhatsAppConfigurationSetupSave =
  "/api/ApplicationConfiguration/WhatsAppConfigurationSetupSave";

//BroadcastMessage
export const POST_GetCustomerContactPersonsList =
  "/api/BroadcastMessage/BroadcastMessageGetCustomerContactPersonsList";
export const POST_BroadcastMessageSend =
  "/api/BroadcastMessage/BroadcastMessageSend";

//Courier
export const POST_GetCourierList = "/api/Courier/GetCourierList";
export const POST_GetCourierDetailByID = "/api/Courier/GetCourierDetailByID";
export const POST_CourierActiveInActive = "/api/Courier/CourierActiveInActive";
export const POST_CourierDelete = "/api/Courier/CourierDelete";
export const POST_CourierInsert = "/api/Courier/CourierInsert";
export const POST_CourierUpdate = "/api/Courier/CourierUpdate";
export const POST_CourierExport = "/api/Courier/CourierExport";
export const POST_GetCourierDDLList = "/api/Courier/GetCourierDDLList";

//OperationStages
export const POST_GetOperationStagesList =
  "/api/OperationStages/GetOperationStagesList";
export const POST_GetOperationStagesDetailByID =
  "/api/OperationStages/GetOperationStagesDetailByID";
export const POST_OperationStagesActiveInActive =
  "/api/OperationStages/OperationStagesActiveInActive";
export const POST_OperationStagesDelete =
  "/api/OperationStages/OperationStagesDelete";
export const POST_OperationStagesInsert =
  "/api/OperationStages/OperationStagesInsert";
export const POST_OperationStagesUpdate =
  "/api/OperationStages/OperationStagesUpdate";
export const POST_OperationStagesExport =
  "/api/OperationStages/OperationStagesExport";

//Companies
export const POST_GetCompanyDetailByID = "/api/Company/GetCompanyDetailByID";
export const POST_CompanyUpdate = "/api/Company/CompanyUpdate";
export const POST_GetCompanyList = "/api/Company/GetCompanyList";
export const POST_CompanyInsertUpdateLicense =
  "/api/Company/CompanyInsertUpdateLicense";
export const POST_GetCompanyLicenseHistory = "/api/Company/GetLicenseHistList";
export const GET_GSTPlansDropDownList = "/api/Company/GetGSTPlansDropDownList";

//CompanyLUTDocument
export const POST_GetCompanyLUTDocumentList =
  "/api/CompanyLUTDocument/GetCompanyLUTDocumentList";
export const POST_GetCompanyLUTDocumentDetailByID =
  "/api/CompanyLUTDocument/GetCompanyLUTDocumentDetailByID";
export const POST_CompanyLUTDocumentActiveInActive =
  "/api/CompanyLUTDocument/CompanyLUTDocumentActiveInActive";
export const POST_CompanyLUTDocumentDelete =
  "/api/CompanyLUTDocument/CompanyLUTDocumentDelete";
export const POST_CompanyLUTDocumentInsert =
  "/api/CompanyLUTDocument/CompanyLUTDocumentInsert";
export const POST_CompanyLUTDocumentUpdate =
  "/api/CompanyLUTDocument/CompanyLUTDocumentUpdate";
export const POST_CompanyLUTDocumentExport =
  "/api/CompanyLUTDocument/CompanyLUTDocumentExport";

//Branches
export const POST_GetBranchesList = "/api/Branches/GetBranchesList";
export const POST_BranchActiveInActive = "/api/Branches/BranchesActiveInActive";
export const POST_BranchDelete = "/api/Branches/BranchesDelete";
export const POST_BranchesExport = "/api/Branches/BranchesExport";
export const POST_BrancheInsert = "/api/Branches/BranchesInsert";
export const POST_GetBranchDetailByID = "/api/Branches/GetBranchesDetailByID";
export const POST_BranchesUpdate = "/api/Branches/BranchesUpdate";
export const POST_BranchLetterHeadImageUpload =
  "/api/Branches/BranchLetterHeadImageUpload";
export const POST_BranchReportingParametersSave =
  "/api/Branches/BranchReportingParametersSave";

//Employee
export const POST_GetEmployeeList = "/api/Employee/GetEmployeeList";
export const POST_EmployeeActiveInActive =
  "/api/Employee/EmployeeUpdateActiveStatus";
export const POST_EmployeeDelete = "/api/Employee/EmployeeDeleteByID";
export const POST_EmployeeExport = "/api/Employee/EmployeeExport";
export const POST_EmployeeInsert = "/api/Employee/EmployeeInsert";
export const POST_GetEmployeeDetailByID = "/api/Employee/GetEmployeeDetailByID";
export const POST_EmployeeUpdate = "/api/Employee/EmployeeUpdate";
export const POST_EmployeeSwitchBranch = "/api/Employee/EmployeeSwitchBranch";
export const POST_UserResetPasswordUpdate =
  "/api/Employee/UserResetPasswordUpdate";

//Vendor
export const POST_GetVendorList = "/api/Vendors/GetVendorsList";
export const POST_VendorActiveInActive = "/api/Vendors/VendorsActiveInActive";
export const POST_VendorDelete = "/api/Vendors/VendorsDelete";
export const POST_VendorExport = "/api/Vendors/VendorsExport";
export const POST_VendorInsert = "/api/Vendors/VendorsInsert";
export const POST_GetVendorDetailByID = "/api/Vendors/GetVendorsDetailByID";
export const POST_VendorUpdate = "/api/Vendors/VendorsUpdate";

//Customer
export const POST_GetCustomerList = "/api/Customer/GetCustomerList";
export const POST_CustomerActiveInActive =
  "/api/Customer/CustomerActiveInActive";
export const POST_CustomerDelete = "/api/Customer/CustomerDelete";
export const POST_GetCustomerDetailByID = "/api/Customer/GetCustomerDetailByID";
export const POST_CustomerInsert = "/api/Customer/CustomerInsert";
export const POST_CustomerUpdate = "/api/Customer/CustomerUpdate";
export const POST_CustomerProjectsInsert =
  "/api/Customer/CustomerProjectsInsert";
export const POST_CustomerProjectsUpdate =
  "/api/Customer/CustomerProjectsUpdate";
export const POST_CustomerProjectAddressInsert =
  "/api/Customer/CustomerProjectAddressInsert";
export const POST_CustomerProjectAddressUpdate =
  "/api/Customer/CustomerProjectAddressUpdate";

export const POST_CustomerProjectsActiveInActive =
  "/api/Customer/CustomerProjectsActiveInActive";

export const POST_GetCustomerProjectAddressDetailByID =
  "/api/Customer/GetCustomerProjectAddressDetailByID";
export const POST_CustomerProjectAddressActiveInActive =
  "/api/Customer/CustomerProjectAddressActiveInActive";
export const POST_CustomerProjectAddressDelete =
  "/api/Customer/CustomerProjectAddressDelete";
export const POST_CustomerContactPersonDetailInsert =
  "/api/Customer/CustomerContactPersonDetailInsert";
export const POST_CustomerContactPersonDetailUpdate =
  "/api/Customer/CustomerContactPersonDetailUpdate";
export const POST_GetCustomerContactPersonDetailByID =
  "/api/Customer/GetCustomerContactPersonDetailByID";
export const POST_CustomerContactPersonActiveInActive =
  "/api/Customer/CustomerContactPersonActiveInActive";
export const POST_CustomerContactPersonDelete =
  "/api/Customer/CustomerContactPersonDelete";

export const POST_CustomerExport = "/api/Customer/CustomerExport";
export const POST_GetCustomerProjectList =
  "/api/Customer/GetCustomerProjectDDLList";
export const POST_GetCustomerProjectDetailByID =
  "/api/Customer/GetCustomerProjectDetailByID";

export const POST_CustomerGSTExemptionDocFileSave =
  "/api/Customer/CustomerGSTExemptionDocFileSave";

export const POST_CustomerRestPassword = "/api/Customer/CustomerRestPassword";
export const POST_CustomerLoginLinkSend = "/api/Customer/CustomerLoginLinkSend";
export const POST_GetCustomerInwardList = "/api/Customer/GetCustomerInwardList";
export const POST_GetCustomerInvoiceList =
  "/api/Invoice/GetCustomerInvoiceList";
export const POST_CustomerInvoiceExport = "/api/Invoice/CustomerInvoiceExport";

export const POST_CustomerResetPasswordUpdate =
  "/api/Customer/CustomerResetPasswordUpdate";

//Material Categories
export const GET_MaterialCategoryTypes =
  "/api/MaterialCategory/GetMaterialCategoryTypes";
export const POST_GetMaterialCategoryListByCategoryType =
  "/api/MaterialCategory/GetMaterialCategoryListByCategoryType";
export const POST_GetMaterialCategoryByID =
  "/api/MaterialCategory/GetMaterialCategoryByID";
export const POST_MaterialCategoryInsert =
  "/api/MaterialCategory/MaterialCategoryInsert";
export const POST_MaterialCategoryUpdate =
  "/api/MaterialCategory/MaterialCategoryUpdate";
export const POST_MaterialCategoryStatusUpdate =
  "/api/MaterialCategory/MaterialCategoryStatusUpdate";
export const POST_MaterialCategoryDelete =
  "/api/MaterialCategory/MaterialCategoryDelete";
export const POST_MaterialCategoryExport =
  "/api/MaterialCategory/MaterialCategoryExport";
export const POST_GetMaterialCategoryDropDownListByCategoryType =
  "/api/MaterialCategory/GetMaterialCategoryDropDownListByCategoryType";

//Departments
export const POST_GetDepartmentList = "/api/Department/GetDepartmentList";
export const POST_GetDepartmentDetailsByID =
  "/api/Department/GetDepartmentDetailsByID";
export const POST_DepartmentInsert = "/api/Department/DepartmentInsert";
export const POST_DepartmentUpdate = "/api/Department/DepartmentUpdate";
export const POST_DepartmentStatusUpdate =
  "/api/Department/DepartmentStatusUpdate";
export const POST_DepartmentDelete = "/api/Department/DepartmentDelete";
export const POST_DepartmentExport = "/api/Department/DepartmentExport";
export const POST_GetDepartmentDropDownList =
  "/api/Department/GetDepartmentDropDownList";
export const POST_GetDepartmentDropDownListByProductGroup =
  "/api/Department/GetDepartmentDropDownListByProductGroup";

//Material Group
export const POST_GetProductGroupsList =
  "/api/ProductGroups/GetProductGroupsList";
export const POST_GetProductGroupsDetailByID =
  "/api/ProductGroups/GetProductGroupsDetailByID";
export const POST_ProductGroupsInsert =
  "/api/ProductGroups/ProductGroupsInsert";
export const POST_ProductGroupsUpdate =
  "/api/ProductGroups/ProductGroupsUpdate";
export const POST_ProductGroupsActiveInActive =
  "/api/ProductGroups/ProductGroupsActiveInActive";
export const POST_ProductGroupsDelete =
  "/api/ProductGroups/ProductGroupsDelete";
export const POST_ProductGroupsExport =
  "/api/ProductGroups/ProductGroupsExport";
export const POST_ProductGroupDropDownListByDepartmentID =
  "/api/ProductGroups/ProductGroupDropDownListByDepartmentID";
export const POST_ProductGroupDropDownList =
  "/api/ProductGroups/ProductGroupDropDownList";

//TestMethod
export const POST_GetTestMethodsList = "/api/TestMethods/GetTestMethodsList";
export const POST_TestMethodsActiveInActive =
  "/api/TestMethods/TestMethodsActiveInActive";
export const POST_TestMethodsDelete = "/api/TestMethods/TestMethodsDelete";
export const POST_TestMethodsExport = "/api/TestMethods/TestMethodsExport";
export const POST_GetTestMethodsVerificationHistoryList =
  "/api/TestMethods/GetTestMethodsVerificationHistoryList";
export const POST_GetTestMethodsDetailByID =
  "/api/TestMethods/GetTestMethodsDetailByID";
export const POST_TestMethodsInsert = "/api/TestMethods/TestMethodsInsert";
export const POST_TestMethodsUpdate = "/api/TestMethods/TestMethodsUpdate";
export const POST_TestMethodsVerifiedUpdate =
  "/api/TestMethods/TestMethodsVerifiedUpdate";

export const POST_TestMethodsReviseInsert =
  "/api/TestMethods/TestMethodsReviseInsert";
export const POST_GetTestMethodsReviseHistList =
  "/api/TestMethods/GetTestMethodsReviseHistList";

//TestMaster
export const POST_GetTestMasterList = "/api/TestMaster/GetTestMasterList";
export const POST_TestMasterActiveInActive =
  "/api/TestMaster/TestMasterActiveInActive";
export const POST_TestMasterDelete = "/api/TestMaster/TestMasterDelete";
export const POST_TestMasterExport = "/api/TestMaster/TestMasterExport";
export const POST_GetTestMasterDetailByID =
  "/api/TestMaster/GetTestMasterDetailByID";
export const POST_TestMasterInsert = "/api/TestMaster/TestMasterInsert";
export const POST_TestMasterUpdate = "/api/TestMaster/TestMasterUpdate";
export const POST_TestMasterImageSave = "/api/TestMaster/TestMasterImageSave";

export const POST_GetMachinesDropDownList =
  "/api/Machines/GetMachinesDropDownListByCompanyID";
export const POST_GetNonStandardParametersDropDownList =
  "/api/TestMaster/GetNonStandardParametersDropDownList";
export const POST_TestMasterProductGroupDepartmentsWiseInsert =
  "/api/TestMaster/TestMasterProductGroupDepartmentsWiseInsert";
export const POST_GetStandardParameterList =
  "/api/TestMaster/GetStandardParameterList";
export const POST_GetMaterialTypeDDLByProductGroup =
  "/api/TestMaster/GetMaterialTypeDDLByProductGroup";
export const POST_GetStandardParameterListUnmapped =
  "/api/TestMaster/GetStandardParameterListUnmapped";
export const POST_GetParameterDDLListAJAX =
  "/api/TestMaster/GetParameterDDLList";

export const POST_GetTestMasterRateList =
  "/api/TestMaster/GetTestMasterRateList";
export const POST_TestMasterRateInsert = "/api/TestMaster/TestMasterRateInsert";
export const POST_GetTestMasterEffectiveDateDDLList =
  "/api/TestMaster/GetTestMasterEffectiveDateDDLList";

export const POST_GetCustomerTestMasterRateList =
  "/api/TestMaster/GetCustomerTestMasterRateList";
export const POST_CustomerTestMasterRateInsert =
  "/api/TestMaster/CustomerTestMasterRateInsert";
export const POST_GetCustomerEffectiveDateDDLList =
  "/api/TestMaster/GetCustomerEffectiveDateDDLList";

export const POST_TestMasterRateListExport =
  "/api/TestMaster/TestMasterRateListExport";
export const POST_CustomerTestMasterRateListExport =
  "/api/TestMaster/CustomerTestMasterRateListExport";

export const POST_TestMasterRateListImportValidateInsert =
  "/api/TestMaster/TestMasterRateListImportValidateInsert";

export const POST_CustomerTestMasterRateListImportValidateInsert =
  "/api/TestMaster/CustomerTestMasterRateListImportValidateInsert";

export const POST_ValidateFormulaExpression =
  "/api/TestMaster/ValidateFormulaExpression";
export const POST_GetShortCodesByMultipleTestIDs =
  "/api/TestMaster/GetShortCodesByMultipleTestIDs";

//Parameters
export const POST_GetParameterList = "/api/Parameter/GetParameterList";
export const POST_GetParameterDetailByID =
  "/api/Parameter/GetParameterDetailByID";
export const POST_ParameterInsert = "/api/Parameter/ParameterInsert";
export const POST_ParameterUpdate = "/api/Parameter/ParameterUpdate";
export const POST_ParameterActiveInActive =
  "/api/Parameter/ParameterActiveInActive";
export const POST_ParameterDelete = "/api/Parameter/ParameterDelete";
export const POST_ParameterExport = "/api/Parameter/ParameterExport";
export const POST_GetMaterialDropDownList =
  "/api/Parameter/GetDDLMaterialTypesByCompanyID";
export const POST_GetTestMethodDropDownList =
  "/api/Parameter/GetDDLTestMethodsByCompanyID";
export const POST_GetMachineParameters = "/api/Parameter/GetMachineParameters";

export const POST_GetUpdateScopeParameterNABLTestMethodRangeList =
  "/api/Parameter/GetUpdateScopeParameterNABLTestMethodRangeList";
export const POST_UpdateScopeParameterNABLTestMethodRangeUpdate =
  "/api/Parameter/UpdateScopeParameterNABLTestMethodRangeUpdate";

//Machines
export const POST_GetMachinesList = "/api/Machines/GetMachinesList";
export const POST_GetMachinesDetailByID = "/api/Machines/GetMachinesDetailByID";
export const POST_MachinesInsert = "/api/Machines/MachinesInsert";
export const POST_MachinesUpdate = "/api/Machines/MachinesUpdate";
export const POST_MachinesActiveInActive =
  "/api/Machines/MachinesActiveInActive";
export const POST_MachinesDelete = "/api/Machines/MachinesDelete";
export const POST_MachinesExport = "/api/Machines/MachinesExport";
export const POST_MachineParametersActiveInActive =
  "/api/Machines/MachineParametersActiveInActive";

//Reference Standard
export const POST_GetReferenceStandardList =
  "/api/ReferenceStandards/GetReferenceStandardList";
export const POST_ReferenceStandardActiveInActive =
  "/api/ReferenceStandards/ReferenceStandardActiveInActive";
export const POST_ReferenceStandardDelete =
  "/api/ReferenceStandards/ReferenceStandardDelete";
export const POST_ReferenceStandardExport =
  "/api/ReferenceStandards/ReferenceStandardExport";
export const POST_ReferenceStandardInsert =
  "/api/ReferenceStandards/ReferenceStandardInsert";
export const POST_GetReferenceStandardDetailByID =
  "/api/ReferenceStandards/GetReferenceStandardDetailByID";
export const POST_ReferenceStandardUpdate =
  "/api/ReferenceStandards/ReferenceStandardUpdate";
export const POST_ProductGroupDropDownListByMultipleDepartmentID =
  "/api/ProductGroups/ProductGroupDropDownListByMultipleDepartmentID";
export const POST_ReferenceStandardReviseInsert =
  "/api/ReferenceStandards/ReferenceStandardReviseInsert";
export const POST_ReferenceStandardReviseList =
  "/api/ReferenceStandards/ReferenceStandardReviseList";
export const POST_GetReferenceStandardVerificationHistoryList =
  "/api/ReferenceStandards/GetReferenceStandardVerificationHistoryList";
export const POST_ReferenceStandardVerifiedUpdate =
  "/api/ReferenceStandards/ReferenceStandardVerifiedUpdate";

//Reference Standard Test Mapping
export const POST_GetRefStandardTestMapList =
  "/api/RefStandardTestMap/GetRefStandardTestMapList";
export const POST_GetReferenceStandardTestMapDetailByID =
  "/api/RefStandardTestMap/GetReferenceStandardTestMapDetailByID";
export const POST_ReferenceStandardTestActiveInActive =
  "/api/RefStandardTestMap/ReferenceStandardTestActiveInActive";
export const POST_ReferenceStandardTestDelete =
  "/api/RefStandardTestMap/ReferenceStandardTestDelete";
export const POST_ReferenceStandardTestInsert =
  "/api/RefStandardTestMap/ReferenceStandardTestInsert";
export const POST_ReferenceStandardTestUpdate =
  "/api/RefStandardTestMap/ReferenceStandardTestUpdate";
export const POST_ReferenceStandardTestExport =
  "/api/RefStandardTestMap/ReferenceStandardTestExport";
export const POST_GetTestMasterStandardParameters =
  "/api/RefStandardTestMap/GetTestMasterStandardParameters";
export const POST_DDLGetReferenceStandardsByTestMasterID =
  "/api/RefStandardTestMap/DDLGetReferenceStandardsByTestMasterID";
export const POST_DDLGetTestMasterByCompanyID =
  "/api/RefStandardTestMap/DDLGetTestMasterByCompanyID";

//Material Inward
export const POST_GetMaterialInwardList =
  "/api/MaterialInward/GetMaterialInwardList";
export const POST_MaterialInwardStatusUpdate =
  "/api/MaterialInward/MaterialInwardStatusUpdate";
export const POST_MaterialInwardDelete =
  "/api/MaterialInward/MaterialInwardDelete";
export const POST_MaterialInwardExport =
  "/api/MaterialInward/MaterialInwardExport";
export const POST_GetMaterialInwardProjectWorkDetailDDLList =
  "/api/MaterialInward/GetMaterialInwardProjectWorkDetailDDLList";
export const POST_GetMaterialInwardDetailByID =
  "/api/MaterialInward/GetMaterialInwardDetailByID";
export const POST_MaterialInwardInsert =
  "/api/MaterialInward/MaterialInwardInsert";
export const POST_MaterialInwardUpdate =
  "/api/MaterialInward/MaterialInwardUpdate";
export const POST_GetVoucherSeriesDDLList =
  "/api/VoucherSeries/GetVoucherSeriesDDLList";
export const POST_GetCustomerDDLList = "/api/Customer/GetCustomerDDLList";
export const POST_GetCustomerDDLListAJAX =
  "/api/Customer/GetCustomerDDLListAJAX";
export const POST_GetCustomerProjectContactPersonDDLList =
  "/api/Customer/GetCustomerProjectContactPersonDDLList"; //also use for StempWriteup
export const POST_GetCustomerProjectAddressDDLList =
  "/api/Customer/GetCustomerProjectAddressDDLList";
export const POST_GetMaterialTypeDDLListByDepartment_ProductGroup =
  "/api/Parameter/GetMaterialTypeDDLListByDepartment_ProductGroup";
export const POST_GetEmployeeDDLList = "/api/Employee/GetEmployeeDDLList";
export const POST_GetMaterialInwardReTestDetailByID =
  "/api/MaterialInward/GetMaterialInwardReTestDetailByID";
export const POST_MaterialInwardReTestInsert =
  "/api/MaterialInward/MaterialInwardReTestInsert";
export const POST_ValidateCustomerCredit =
  "/api/Customer/ValidateCustomerCredit";
export const POST_MaterialInwardHeaderDetailChange =
  "/api/MaterialInward/MaterialInwardHeaderDetailChange";
export const POST_DDLGetInwardListForInwardClubing =
  "/api/MaterialInward/DDLGetInwardListForInwardClubing";

//TC / Test Allocation
export const POST_GetTCAllocationList = "/api/TCAllocation/GetTCAllocationList";
export const POST_TCAllocationExport = "/api/TCAllocation/TCAllocationExport";
export const POST_GetDDLTestMasterByDepartmentProductGroupMaterialType =
  "/api/TCAllocation/GetDDLTestMasterByDepartmentProductGroupMaterialType";
export const POST_GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID =
  "/api/TCAllocation/GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID";
export const POST_GetTCAllocationDetail =
  "/api/TCAllocation/GetTCAllocationDetail";
export const POST_TCAllocationSave = "/api/TCAllocation/TCAllocationSave";
export const POST_GetMachiningProcessDDLList =
  "/api/TCAllocation/GetMachiningProcessDDLList";
export const POST_TCAllocationDelete = "/api/TCAllocation/TCAllocationDelete";
export const POST_GetTestParametersList =
  "/api/TCAllocation/GetTestParametersList";
export const POST_GetTestWiseDefineMoreRatesList =
  "/api/TCAllocation/GetTestWiseDefineMoreRatesList";
export const POST_GetReferenceStandardTestSubGroupDDL =
  "/api/TCAllocation/GetReferenceStandardTestSubGroupDDL";
export const POST_GetParametersPreferenceListBasedOnRefStandardTestSubGroup =
  "/api/TCAllocation/GetParametersPreferenceListBasedOnRefStandardTestSubGroup";

//Inward Approval
export const POST_GetInwardApprovalList =
  "/api/InwardApproval/GetInwardApprovalList";
export const POST_InwardApprovalUpdateStatus =
  "/api/InwardApproval/InwardApprovalUpdateStatus";
export const POST_GetInwardApprovalDetailByID =
  "/api/InwardApproval/GetInwardApprovalDetailByID";
export const POST_InwardApprovalExport =
  "/api/InwardApproval/InwardApprovalExport";

//Testing
export const POST_GetTestingList = "/api/Testing/GetTestingList";
export const POST_DDLGetTestMasterByDepartmentID =
  "/api/Testing/DDLGetTestMasterByDepartmentID";
export const POST_DDLGetTestMasterByInwardMaterialID =
  "/api/Testing/DDLGetTestMasterByInwardMaterialID";
export const POST_GetTestingsDetailByID = "/api/Testing/GetTestingsDetailByID";
export const POST_DDLParametersRange_SubGroupByReferenceStandardID_TestMasterID =
  "/api/Testing/DDLParametersRange_SubGroupByReferenceStandardID_TestMasterID";
export const POST_TestingSave = "/api/Testing/TestingsSave";
export const POST_TestingFilesSave = "/api/Testing/TestingsFilesSave";
export const POST_GetTestingsApprovalDetailByID =
  "/api/Testing/GetTestingsApprovalDetailByID";
export const POST_TestingsApprovalInsert =
  "/api/Testing/TestingsApprovalInsert";
export const POST_TestingCSVFileImport = "/api/Testing/TestingCSVFileImport";
export const POST_GetTestingsInwardMaterialDetailByID =
  "/api/Testing/GetTestingsInwardMaterialDetailByID";
export const POST_GetTestingsParametersListOnTestMethodChange =
  "/api/Testing/GetTestingsParametersListOnTestMethodChange";

export const POST_GetTestingDateWiseTestMethodDDLList =
  "/api/Testing/GetTestingDateWiseTestMethodDDLList";
export const POST_GetTestingDateWiseParameterTestMethodDDLList =
  "/api/Testing/GetTestingDateWiseParameterTestMethodDDLList";

export const POST_TestingsDelete = "/api/Testing/TestingsDelete";

export const POST_GetTestingParameterFormulaExpressionResult =
  "/api/Testing/GetTestingParameterFormulaExpressionResult";

export const POST_TestingFetchMachineParameterResults =
  "/api/Testing/TestingFetchMachineParameterResults";
export const POST_TestingMachineList = "/api/Testing/TestingMachineList";

//Reportings
export const POST_GetReportingsList = "/api/Reportings/GetReportingsList";
export const POST_ReportingsUploadScanCopiesInsertUpdate =
  "/api/Reportings/ReportingsUploadScanCopiesInsertUpdate";
export const POST_GetReportingsDetailByInwardMaterialID =
  "/api/Reportings/GetReportingsDetailByInwardMaterialID";
export const POST_ReportingsInsert = "/api/Reportings/ReportingsInsert";
export const POST_GetReportingsPrintingDownload =
  "/api/Reportings/GetReportingsPrintingDownload";
export const POST_ReportingsDelete = "/api/Reportings/ReportingsDelete";
export const POST_GetReportingsSendDraftCopyEmail =
  "/api/Reportings/GetReportingsSendDraftCopyEmail";
export const POST_ReportingsSendDraftCopyEmailSend =
  "/api/Reportings/ReportingsSendDraftCopyEmailSend";
export const POST_GetReportingsLogoValidityByReportingDate =
  "/api/Reportings/GetReportingsLogoValidityByReportingDate";

//Upload Scan Copy
export const POST_GetUploadScanCopiesList =
  "/api/UploadScanCopies/GetUploadScanCopiesList";
export const POST_GetUploadScanCopyAdditionalDocumentsDetailByID =
  "/api/UploadScanCopies/GetUploadScanCopyAdditionalDocumentsDetailByID";
export const POST_UploadScanCopyAdditionalDocumentsSave =
  "/api/UploadScanCopies/UploadScanCopyAdditionalDocumentsSave";
export const POST_DDLGetInwardsNoByCustomerID =
  "/api/UploadScanCopies/DDLGetInwardsNoByCustomerID";
export const POST_GetUploadScanCopiesGetDetailByInwardID =
  "/api/UploadScanCopies/GetUploadScanCopiesGetDetailByInwardID";
export const POST_UploadScanCopiesSaveUpdate =
  "/api/UploadScanCopies/UploadScanCopiesSaveUpdate";
export const POST_UploadScanCopiesDelete =
  "/api/UploadScanCopies/UploadScanCopiesDelete";

//Control Center
export const POST_GetControlCenterList =
  "/api/ControlCenter/GetControlCenterList";
export const POST_GetProcessFormDDL =
  "/api/ControlCenter/GetProcessFormListDDL";
export const POST_GetProcessFormStatusDDL =
  "/api/ControlCenter/GetProcessFormStatusListDDL";
export const POST_GetCustomerContactPersonDDL =
  "/api/Customer/GetCustomerContactPersonsListByCustomerID";
export const POST_GetCustomerContactPersonDDLByCustomerProject =
  "/api/Customer/GetCustomerContactPersonsListByCustomerIDAndCustomerProjectID";
export const POST_GetControlCenterInwardStatistics =
  "/api/ControlCenter/GetControlCenterInwardStatisticsList";
export const POST_GetControlCenterScanCopyEmailDetailList =
  "/api/ControlCenter/GetControlCenterScanCopyEmailDetailList";
export const POST_GetControlCenterInvoiceEmailDetailList =
  "/api/ControlCenter/GetControlCenterInvoiceEmailDetailList";
export const POST_GetControlCenterInwardMaterialMachineCertificateEmailDetail =
  "/api/ControlCenter/GetControlCenterInwardMaterialMachineCertificateEmailDetail";
export const POST_ControlCenterScanCopyEmailSend =
  "/api/ControlCenter/ControlCenterScanCopyEmailSend";
export const POST_GetSampleRequestFormDownload =
  "/api/ControlCenter/GetSampleRequestFormDetailDownload";
export const POST_GetLabFormDownload =
  "/api/ControlCenter/GetLabFormDetailDownload";

export const POST_ControlCenterInwardTPIDetailsSave =
  "/api/ControlCenter/ControlCenterInwardTPIDetailsSave";

export const POST_ControlCenterMachineCertificateEmailSend =
  "/api/ControlCenter/ControlCenterMachineCertificateEmailSend";

export const POST_HoldInward = "/api/ControlCenter/HoldInward";
export const POST_ControlCenterGetInwardTestDefineMoreRatesList =
  "/api/TCAllocation/ControlCenterGetInwardTestDefineMoreRatesList";
export const POST_ControlCenterInwardTestDefineMoreRatesSave =
  "/api/TCAllocation/ControlCenterInwardTestDefineMoreRatesSave";

//Machine Configuration
export const POST_GetMachineConfigurationList =
  "/api/MachiningConfigurations/GetMachiningConfigurationsList";
export const POST_MachineConfigurationActiveInActive =
  "/api/MachiningConfigurations/MachiningConfigurationsActiveInActive";
export const POST_MachineConfigurationDelete =
  "/api/MachiningConfigurations/MachiningConfigurationsDelete";
export const POST_MachineConfigurationExport =
  "/api/MachiningConfigurations/MachiningConfigurationsExport";
export const POST_MachineConfigurationInsert =
  "/api/MachiningConfigurations/InsertMachiningConfigurations";
export const POST_GetMachineConfigurationDetailByID =
  "/api/MachiningConfigurations/GetMachiningConfigurationsDetailByID";
export const POST_MachineConfigurationUpdate =
  "/api/MachiningConfigurations/UpdateMachiningConfigurations";

//Machining Outward
export const POST_GetMachiningOutwardList =
  "/api/MachiningOutward/GetMachiningOutwardList";
export const POST_GetProcessListForOutward =
  "/api/MachiningOutward/GetProcessListForOutward";
export const POST_MachiningOutwardActiveInActive =
  "/api/MachiningOutward/MachiningOutwardActiveInActive";
export const POST_MachiningOutwardDelete =
  "/api/MachiningOutward/MachiningOutwardDelete";
export const POST_MachiningOutwardExport =
  "/api/MachiningOutward/MachiningOutwardExport";
export const POST_InsertMachiningOutward =
  "/api/MachiningOutward/InsertMachiningOutward";
export const POST_UpdateMachiningOutward =
  "/api/MachiningOutward/UpdateMachiningOutward";
export const POST_GetMachiningOutwardDetailByID =
  "/api/MachiningOutward/GetMachiningOutwardDetailByID";
export const POST_GetVendorsDDLList = "/api/Vendors/GetVendorsDDLList";
export const POST_GetMachiningOutwardInwardDetailByID =
  "/api/MachiningOutward/GetMachiningOutwardInwardDetailByID";
export const POST_MachiningOutwardInwardInsert =
  "/api/MachiningOutward/MachiningOutwardInwardInsert";
export const POST_MachiningOutwardGetPassPrint =
  "/api/MachiningOutward/GetMachiningOutwardGetPassPrintDownload";
export const POST_MachiningOutwardInwardDelete =
  "/api/MachiningOutward/MachiningOutwardInwardDelete";

//Report Dispatch
export const POST_GetReportDispatchList =
  "/api/ReportDispatch/GetReportDispatchList";
export const POST_ReportDispatchActiveInActive =
  "/api/ReportDispatch/ReportDispatchActiveInActive";
export const POST_ReportDispatchDelete =
  "/api/ReportDispatch/ReportDispatchDelete";
export const POST_InsertReportDispatch =
  "/api/ReportDispatch/InsertReportDispatch";
export const POST_UpdateReportDispatch =
  "/api/ReportDispatch/UpdateReportDispatch";
export const POST_GetReportDispatchDetailByID =
  "/api/ReportDispatch/GetReportDispatchDetailByID";
export const POST_GetReportDispatchTCNoDDLList =
  "/api/ReportDispatch/GetReportDispatchTCNoDDLList";
export const POST_GetReportDispatchTestNameByInwardMaterialID =
  "/api/ReportDispatch/GetReportDispatchTestNameByInwardMaterialID";

export const POST_ReportDispatchPrint =
  "/api/ReportDispatch/GetReportDispatchPrintByID";
export const POST_GetReportDispatchPrintLabel =
  "/api/ReportDispatch/GetReportDispatchPrintLabel";
export const POST_GetReportDispatchInwardNoClubing =
  "/api/ReportDispatch/GetReportDispatchInwardNoClubing";

//Material Dispatch
export const POST_GetMaterialDispatchList =
  "/api/MaterialDispatch/GetMaterialDispatchList";
export const POST_MaterialDispatchActiveInActive =
  "/api/MaterialDispatch/MaterialDispatchActiveInActive";
export const POST_MaterialDispatchDelete =
  "/api/MaterialDispatch/MaterialDispatchDelete";
export const POST_InsertMaterialDispatch =
  "/api/MaterialDispatch/InsertMaterialDispatch";
export const POST_UpdateMaterialDispatch =
  "/api/MaterialDispatch/UpdateMaterialDispatch";
export const POST_GetMaterialDispatchDetailByID =
  "/api/MaterialDispatch/GetMaterialDispatchDetailByID";
export const POST_GetMaterialDispatchTCNoDDLList =
  "/api/MaterialDispatch/GetMaterialDispatchTCNoDDLList";
export const POST_MaterialDispatchPrint =
  "/api/MaterialDispatch/GetMaterialDispatchPrintByID";
export const POST_GetMaterialDispatchPrintLabel =
  "/api/MaterialDispatch/GetMaterialDispatchPrintLabel";

//Amendment
export const POST_Amendment_GetInwardMaterialDetails =
  "/api/Amendment/Amendment_GetInwardMaterialDetails";
export const POST_Amendment_Save = "/api/Amendment/AmendmentSave";

//Machines Calibration
export const POST_GetMachineCalibrationList =
  "/api/MachineCalibration/GetMachineCalibrationList";
export const POST_GetMachineCalibrationDetailByID =
  "/api/MachineCalibration/GetMachineCalibrationDetailByID";
export const POST_MachineCalibrationInsert =
  "/api/MachineCalibration/MachineCalibrationSave";
export const POST_MachineCalibrationUpdate =
  "/api/MachineCalibration/MachineCalibrationUpdate";
export const POST_MachineCalibrationActiveInActive =
  "/api/MachineCalibration/MachineCalibrationActiveInActive";
export const POST_MachineCalibrationDelete =
  "/api/MachineCalibration/MachineCalibrationDelete";
export const POST_MachineCalibrationExport =
  "/api/MachineCalibration/MachineCalibrationExport";
export const POST_GetMachineCalibrationDetailByMachineID =
  "/api/MachineCalibration/GetMachineCalibrationDetailByMachineID";

//Reports
export const POST_GetInwardRegisterReportList =
  "/api/Reports/InwardRegisterReportList";
export const POST_GetInwardRegisterReportExport =
  "/api/Reports/InwardRegisterReportExport";
export const POST_GetReportProcessStatusList =
  "/api/Reports/GetReportProcessStatusList";
export const POST_GetProcessStatusReportExport =
  "/api/Reports/GetProcessStatusReportExport";
export const POST_GetReportDispatchReportList =
  "/api/Reports/GetReportDispatchReportList";
export const POST_GetReportDispatchReportExport =
  "/api/Reports/GetReportDispatchReportExport";
export const POST_GetReportDispatchMaterialList =
  "/api/Reports/GetReportDispatchMaterialList";
export const POST_GetReportDispatchMaterialExport =
  "/api/Reports/GetReportDispatchMaterialExport";
export const POST_GetReportPendingTestingList =
  "/api/Reports/GetReportPendingTestingList";
export const POST_GetReportPendingTestingExport =
  "/api/Reports/GetReportPendingTestingExport";

export const POST_GetReportChatHistoryList =
  "/api/Reports/GetReportChatHistoryList";
export const POST_GetReportChatHistoryExport =
  "/api/Reports/GetReportChatHistoryExport";

export const POST_GetCommunicationLogList =
  "/api/Reports/GetCommunicationLogList";
export const GET_GetCommunicationLogTypes =
  "/api/Reports/GetCommunicationLogTypes";
export const POST_GetCommunicationLogExport =
  "/api/Reports/GetCommunicationLogExport";

export const GET_GetMachinCalibrationReportType =
  "/api/Reports/GetMachinCalibrationReportType";
export const POST_GetMachinCalibrationExpiryList =
  "/api/Reports/GetMachinCalibrationExpiryList";
export const POST_GetMachinCalibrationExpiryExport =
  "/api/Reports/GetMachinCalibrationExpiryExport";

//Roles
export const POST_GetRolesList = "/api/Roles/GetRolesList";
export const POST_GetRolesDetailByID = "/api/Roles/GetRolesDetailByID";
export const POST_RolesInsert = "/api/Roles/RolesInsert";
export const POST_RolesUpdate = "/api/Roles/RolesUpdate";
export const POST_RolesActiveInActive = "/api/Roles/RolesActiveInActive";
export const POST_RolesDelete = "/api/Roles/RolesDelete";
export const POST_GetRolesExport = "/api/Roles/RolesExport";
export const POST_GetFormsList = "/api/Common/GetFormsList";

//Dashboard
export const POST_GetTodaysSummaryData = "/api/Dashboard/GetTodaysSummaryData";
export const POST_GetActiveInwardData = "/api/Dashboard/GetActiveInwardData";
export const POST_GetTopCustomersData = "/api/Dashboard/GetTopCustomersData";
export const POST_GetTopTestsData = "/api/Dashboard/GetTopTestsData";
export const POST_GetTopDepartmentsData =
  "/api/Dashboard/GetTopDepartmentsData";
export const POST_GetTopMachinesData = "/api/Dashboard/GetTopMachinesData";
export const POST_GetInwardDispatchBarChartData =
  "/api/Dashboard/GetInwardDispatchBarChartData";
export const POST_GetActivityLogData = "/api/Dashboard/GetActivityLogData";

//Master Import
export const POST_GetMasterTypes = "/api/MasterImport/GetMasterTypes";
export const POST_MasterDataImportValidateInsertCustomer =
  "/api/MasterImport/MasterDataImportValidateInsertCustomer";
export const POST_MasterDataImportValidateInsertTestMethods =
  "/api/MasterImport/MasterDataImportValidateInsertTestMethods";
export const POST_MasterDataImportValidateInsertParameters =
  "/api/MasterImport/MasterDataImportValidateInsertParameters";
export const POST_MasterDataImportValidateInsertReferenceStandards =
  "/api/MasterImport/MasterDataImportValidateInsertReferenceStandards";
export const POST_MasterDataImportValidateInsertMaterialGroup =
  "/api/MasterImport/MasterDataImportValidateInsertMaterialGroup";
export const POST_MasterDataImportValidateInsertTestMaster =
  "/api/MasterImport/MasterDataImportValidateInsertTestMaster";
export const POST_MasterDataImportValidateInsertTestMasterStandardParameters =
  "/api/MasterImport/MasterDataImportValidateInsertTestMasterStandardParameters";
export const POST_MasterDataImportValidateInsertTestMasterNonStandardParameters =
  "/api/MasterImport/MasterDataImportValidateInsertTestMasterNonStandardParameters";
export const POST_MasterDataImportValidateInsertMachinesMaster =
  "/api/MasterImport/MasterDataImportValidateInsertMachinesMaster";

//Cancel Test
export const POST_CancelTest_GetInwardMaterialDetails =
  "/api/TCAllocation/CancelTest_GetInwardMaterialDetails";
export const POST_CancelTestSave = "/api/TCAllocation/CancelTestSave";

//Print Label
export const POST_GetPrintLabelList = "/api/PrintLabel/GetPrintLabelList";
export const POST_GetPrintLabel = "/api/PrintLabel/GetPrintLabel";

//Chat Box
export const POST_GetChatBoxList = "/api/ChatBox/GetChatBoxList";
export const POST_ChatBoxEmployeeIsReadMessage =
  "/api/ChatBox/ChatBoxEmployeeIsReadMessage";
export const POST_ChatBoxEmployeeMessageInsert =
  "/api/ChatBox/ChatBoxEmployeeMessageInsert";
export const POST_GetSpecificEmployeeMessageList =
  "/api/ChatBox/GetSpecificEmployeeMessageList";
export const POST_GetEmployeeUnReadMessageCount =
  "/api/ChatBox/GetEmployeeUnReadMessageCount";
export const POST_ChatBoxEmployeeMessageDelete =
  "/api/ChatBox/ChatBoxEmployeeMessageDelete";

//Rewise
export const POST_Rewise_GetInwardMaterialDetails =
  "/api/TCAllocation/Rewise_GetInwardMaterialDetails";
export const POST_RewiseInwardMaterialSave =
  "/api/TCAllocation/RewiseInwardMaterialSave";

//Proforma Invoice

export const POST_GetExpenseListByCompanyID =
  "/api/Expense/GetExpenseListByCompanyID";
export const POST_GetBillingCustomerDetails =
  "/api/PerformaInvoice/GetBillingCustomerDetails";
export const POST_GetPerformaInvoiceList =
  "/api/PerformaInvoice/GetPerformaInvoiceList";
export const POST_PerformaInvoiceExport =
  "/api/PerformaInvoice/PerformaInvoiceExport";
export const POST_PerformaInvoiceCancel =
  "/api/PerformaInvoice/PerformaInvoiceCancel";
export const POST_GetPerformaInvoiceInwardNoListByCustomerID =
  "/api/PerformaInvoice/DDLGetInwardList";
export const POST_GetPerformaInvoiceTCNoListByInwardIDs =
  "/api/PerformaInvoice/DDLGetTCNoList";
export const POST_GetPerformaInvoiceTestAndMachiningListByInwardMaterialID =
  "/api/PerformaInvoice/GetTestAndMachiningListByInwardMaterialID";
export const POST_PerformaInvoiceInsert =
  "/api/PerformaInvoice/PerformaInvoiceInsert";
export const POST_GetPerformaInvoiceDetailByID =
  "/api/PerformaInvoice/GetDetailByID";
export const POST_PerformaInvoiceUpdate =
  "/api/PerformaInvoice/PerformaInvoiceUpdate";
export const POST_GetPerformaInvoiceSendEmailDetails =
  "/api/PerformaInvoice/GetPerformaInvoiceSendEmailDetails";
export const POST_PerformaInvoiceEmailSend =
  "/api/PerformaInvoice/PerformaInvoiceEmailSend";
export const POST_PerformaInvoiceDownloadPDF =
  "/api/PerformaInvoice/GetPerformaInvoiceDownloadPDF";
export const POST_PerformaInvoicePrint =
  "/api/PerformaInvoice/GetPerformaInvoicePrintHTMLContents";
export const POST_GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot =
  "/api/PerformaInvoice/GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot";
export const POST_GetTestRateByUnitID =
  "/api/PerformaInvoice/GetTestRateByUnitID";

//Invoice
export const POST_GetInvoiceInwardNoListByCustomerID =
  "/api/Invoice/DDLGetInwardList";
export const POST_GetInvoiceTCNoListByInwardIDs = "/api/Invoice/DDLGetTCNoList";
export const POST_GetInvoiceTestAndMachiningListByInwardMaterialID =
  "/api/Invoice/GetTestAndMachiningListByInwardMaterialID";
export const POST_InvoiceInsert = "/api/Invoice/InvoiceInsert";
export const POST_GetInvoiceList = "/api/Invoice/GetInvoiceList";
export const POST_InvoiceExport = "/api/Invoice/InvoiceExport";
export const POST_InvoiceCancel = "/api/Invoice/InvoiceCancel";
export const POST_GetInvoiceSendEmailDetails =
  "/api/Invoice/GetInvoiceSendEmailDetails";
export const POST_InvoiceEmailSend = "/api/Invoice/InvoiceEmailSend";
export const POST_InvoiceDownloadPDF = "/api/Invoice/GetInvoiceDownloadPDF";
export const POST_InvoicePrint = "/api/Invoice/GetInvoicePrintHTMLContents";
export const POST_GetInvoiceDetailByID = "/api/Invoice/GetDetailByID";
export const POST_InvoiceUpdate = "/api/Invoice/InvoiceUpdate";
export const POST_InvoiceBillFileUpload = "/api/Invoice/BillFileUpload";
export const POST_InvoiceChangeDetails =
  "/api/Invoice/BillFileUploadWithNarration";
export const POST_EInvoice_Generate = "/api/EInvoice/EInvoice_Generate";

//Expense
export const POST_GetExpenseList = "/api/Expense/GetExpenseList";
export const POST_ExpenseExport = "/api/Expense/ExpenseExport";
export const POST_ExpenseDelete = "/api/Expense/ExpenseDelete";
export const POST_ExpenseActiveInActive = "/api/Expense/ExpenseActiveInActive";
export const POST_GetExpenseDetailByID = "/api/Expense/GetExpenseDetailByID";
export const POST_ExpenseInsert = "/api/Expense/ExpenseInsert";
export const POST_ExpenseUpdate = "/api/Expense/ExpenseUpdate";

//Advance Receipt
export const POST_GetPaymentModeList = "/api/AdvanceReceipt/GetPaymentModeList";
export const POST_GetAdvanceReceiptList =
  "/api/AdvanceReceipt/GetAdvanceReceiptList";
export const POST_AdvanceReceiptCancelled =
  "/api/AdvanceReceipt/AdvanceReceiptCancelled";
export const POST_GetAdvanceReceiptDetailByID =
  "/api/AdvanceReceipt/GetAdvanceReceiptDetailByID";
export const POST_AdvanceReceiptExport =
  "/api/AdvanceReceipt/AdvanceReceiptExport";
export const POST_AdvanceReceiptInsert =
  "/api/AdvanceReceipt/AdvanceReceiptInsert";
export const POST_AdvanceReceiptUpdate =
  "/api/AdvanceReceipt/AdvanceReceiptUpdate";
export const POST_GetBranchBankDDLList =
  "/api/AdvanceReceipt/GetBranchBankDDLList";
export const POST_GetAdvanceReceiptPrint =
  "/api/AdvanceReceipt/GetAdvanceReceiptPrintHTMLContents";

//Payment Receipt
export const POST_GetPaymentReceiptList =
  "/api/PaymentReceipt/GetPaymentReceiptList";
export const POST_PaymentReceiptExport =
  "/api/PaymentReceipt/PaymentReceiptExport";
export const POST_PaymentReceiptCancel =
  "/api/PaymentReceipt/PaymentReceiptCancel";
export const POST_GetPaymentReceiptPrint =
  "/api/PaymentReceipt/GetPaymentReceiptPrintHTMLContents";
export const POST_GetPaymentReceiptCustomerDetails =
  "/api/PaymentReceipt/GetPaymentReceiptCustomerDetails";
export const POST_PaymentReceiptInsert =
  "/api/PaymentReceipt/PaymentReceiptInsert";
export const POST_PaymentReceiptUpdate =
  "/api/PaymentReceipt/PaymentReceiptUpdate";
export const POST_GetPaymentReceiptDetailByID =
  "/api/PaymentReceipt/GetPaymentReceiptDetailByID";

//Account Reports
export const POST_GetReportCustomerOutstandingList =
  "/api/Reports/GetReportCustomerOutstandingList";
export const POST_GetReportCustomerOutstandingExport =
  "/api/Reports/GetReportCustomerOutstandingExport";
export const POST_GetReportCustomerOutstandingRegisterList =
  "/api/Reports/GetReportCustomerOutstandingRegisterList";
export const POST_GetReportCustomerOutstandingRegisterExport =
  "/api/Reports/GetReportCustomerOutstandingRegisterExport";
export const POST_GetReportInvoiceRegisterList =
  "/api/Reports/GetReportInvoiceRegisterList";
export const POST_GetReportInvoiceRegisterExport =
  "/api/Reports/GetReportInvoiceRegisterExport";
export const POST_GetReportPendingInvoiceList =
  "/api/Reports/GetReportPendingInvoiceList";
export const POST_GetReportPendingInvoiceExport =
  "/api/Reports/GetReportPendingInvoiceExport";
export const POST_GetReportPaymentReceiptRegisterList =
  "/api/Reports/GetReportPaymentReceiptRegisterList";
export const POST_GetReportPaymentReceiptRegisterExport =
  "/api/Reports/GetReportPaymentReceiptRegisterExport";
export const POST_GetReportAdvanceReceiptRegisterList =
  "/api/Reports/GetReportAdvanceReceiptRegisterList";
export const POST_GetReportAdvanceReceiptRegisterExport =
  "/api/Reports/GetReportAdvanceReceiptRegisterExport";
export const POST_GetReportLedgerList = "/api/Reports/GetReportLedgerList";
export const POST_GetReportLedgerExport = "/api/Reports/GetReportLedgerExport";

//Send Email Configuration
export const POST_GetInstanceTypeList =
  "/api/SendEmailConfiguration/GetInstanceTypeList";
export const POST_InstanceTypeListInsert =
  "/api/SendEmailConfiguration/InstanceTypeListInsert";
export const POST_GetEmailTypeList =
  "/api/SendEmailConfiguration/GetEmailTypeList";
export const POST_EmailTemplatesContentSave =
  "/api/SendEmailConfiguration/EmailTemplatesContentSave";

//Credit Note
export const POST_GetCreditNoteList = "/api/CreditNote/GetCreditNoteList";
export const POST_CreditNoteExport = "/api/CreditNote/CreditNoteExport";
export const POST_CreditNoteInsert = "/api/CreditNote/CreditNoteInsert";
export const POST_GetCreditNoteDetailByID =
  "/api/CreditNote/GetCreditNoteDetailByID";
export const POST_CreditNoteUpdate = "/api/CreditNote/CreditNoteUpdate";
export const POST_GetCreditNoteInvoiceDropDownList =
  "/api/CreditNote/GetInvoiceDropDownList";
export const POST_GetCreditNoteInvoiceDetailByID =
  "/api/CreditNote/GetInvoiceDetailByID";
export const POST_CreditNoteCancel = "/api/CreditNote/CreditNoteCancel";
export const POST_GetCreditNoteSendEmailDetail =
  "/api/CreditNote/GetCreditNoteSendEmailDetail";
export const POST_CreditNoteEmailSend = "/api/CreditNote/CreditNoteEmailSend";
export const POST_GetCreditNotePrintHTMLContents =
  "/api/CreditNote/GetCreditNotePrintHTMLContents";

//Machine Result CSV File Import
export const POST_MachineResultCSVFileImport =
  "/api/MachineResultCSVFileImport/MachineResultCSVFileImport";

//WhatsApp Configuration
export const POST_GetWhatsAppConfigurationInstanceTypeList =
  "/api/WhatsAppConfiguration/GetWhatsAppConfigurationInstanceTypeList";
export const POST_WhatsAppConfigurationSave =
  "/api/WhatsAppConfiguration/WhatsAppConfigurationSave";
export const POST_UploadScanCopiesWhatsAppMessageSend =
  "/api/UploadScanCopies/UploadScanCopiesWhatsAppMessageSend";
export const POST_PerformaInvoiceWhatsAppMessageSend =
  "/api/PerformaInvoice/PerformaInvoiceWhatsAppMessageSend";
export const POST_InvoiceWhatsAppMessageSend =
  "/api/Invoice/InvoiceWhatsAppMessageSend";
export const POST_GetCustomerContactPersonsListByInvoiceIDs =
  "/api/PaymentReceipt/GetCustomerContactPersonsListByInvoiceIDs";
export const POST_PaymentReceiptWhatsAppMessageSend =
  "/api/PaymentReceipt/PaymentReceiptWhatsAppMessageSend";
export const POST_AdvanceReceiptWhatsAppMessageSend =
  "/api/AdvanceReceipt/AdvanceReceiptWhatsAppMessageSend";
export const POST_CreditNoteWhatsAppMessageSend =
  "/api/CreditNote/CreditNoteWhatsAppMessageSend";

//MixDesignMaster
export const GET_MixDesignMasterTypes = "/api/Common/GetMixDesignMasterTypes";
export const POST_GetMixDesignMasterListByMixDesignMasterType =
  "/api/MixDesignMaster/GetMixDesignMasterListByMixDesignMasterType";
export const POST_GetMixDesignMasterByID =
  "/api/MixDesignMaster/GetMixDesignMasterByID";
export const POST_MixDesignMasterInsert =
  "/api/MixDesignMaster/MixDesignMasterInsert";
export const POST_MixDesignMasterUpdate =
  "/api/MixDesignMaster/MixDesignMasterUpdate";
export const POST_MixDesignMasterStatusUpdate =
  "/api/MixDesignMaster/MixDesignMasterStatusUpdate";
export const POST_MixDesignMasterDelete =
  "/api/MixDesignMaster/MixDesignMasterDelete";
export const POST_MixDesignMasterExport =
  "/api/MixDesignMaster/MixDesignMasterExport";
export const POST_GetMixDesignMasterDropDownListByMixDesignMasterType =
  "/api/MixDesignMaster/GetMixDesignMasterDropDownListByMixDesignMasterType";
export const POST_GetMixDesignMasterDropDownListAll =
  "/api/MixDesignMaster/GetMixDesignMasterDropDownListAll";

//NABL Scope
export const POST_GetNABLScopeList = "/api/NABLScope/GetNABLScopeList";
export const POST_GetNABLScopeDetailByID =
  "/api/NABLScope/GetNABLScopeDetailByID";
export const POST_NABLScopeActiveInActive =
  "/api/NABLScope/NABLScopeActiveInActive";
export const POST_NABLScopeDelete = "/api/NABLScope/NABLScopeDelete";
export const POST_NABLScopeExport = "/api/NABLScope/NABLScopeExport";
export const POST_NABLScopeInsert = "/api/NABLScope/NABLScopeInsert";
export const POST_NABLScopeUploadDocuments =
  "/api/NABLScope/NABLScopeUploadDocuments";
export const POST_NABLScopeUpdate = "/api/NABLScope/NABLScopeUpdate";

//Document Management
export const POST_GetDocumentManagementList =
  "/api/DocumentManagement/GetDocumentManagementList";
export const POST_GetDocumentManagementDetailByID =
  "/api/DocumentManagement/GetDocumentManagementDetailByID";
export const POST_DocumentManagementInsert =
  "/api/DocumentManagement/DocumentManagementInsert";
export const POST_DocumentManagementUpdate =
  "/api/DocumentManagement/DocumentManagementUpdate";
export const POST_DocumentManagementActiveInActive =
  "/api/DocumentManagement/DocumentManagementActiveInActive";
export const POST_DocumentManagementDelete =
  "/api/DocumentManagement/DocumentManagementDelete";
export const POST_DocumentManagementRewiseInsert =
  "/api/DocumentManagement/DocumentManagementRewiseInsert";
export const POST_GetDocumentManagementViewHistory =
  "/api/DocumentManagement/GetDocumentManagementViewHistory";

//Logo Validity
export const GET_GetLogoTypeDropDownList = "/api/LogoValidity/GetLogoTypeDDL";
export const POST_GetLogoValidityList = "/api/LogoValidity/GetLogoValidityList";
export const POST_GetLogoValidityDetailByID =
  "/api/LogoValidity/GetLogoValidityDetailByID";
export const POST_LogoValidityActiveInActive =
  "/api/LogoValidity/LogoValidityActiveInActive";
export const POST_LogoValidityDelete = "/api/LogoValidity/LogoValidityDelete";
export const POST_LogoValidityExport = "/api/LogoValidity/LogoValidityExport";
export const POST_LogoValidityInsert = "/api/LogoValidity/LogoValidityInsert";
export const POST_LogoValidityUpdate = "/api/LogoValidity/LogoValidityUpdate";

//Inventory Items
export const POST_GetInventoryItemsList =
  "/api/InventoryItems/GetInventoryItemsList";
export const POST_InventoryItemsExport =
  "/api/InventoryItems/InventoryItemsExport";
export const POST_InventoryItemsDelete =
  "/api/InventoryItems/InventoryItemsDelete";
export const POST_InventoryItemsActiveInActive =
  "/api/InventoryItems/InventoryItemsActiveInActive";
export const POST_GetInventoryItemsDetailByID =
  "/api/InventoryItems/GetInventoryItemsDetailByID";
export const POST_InventoryItemsInsert =
  "/api/InventoryItems/InventoryItemsInsert";
export const POST_InventoryItemsUpdate =
  "/api/InventoryItems/InventoryItemsUpdate";
export const POST_GetInventoryItemsListDLL =
  "/api/InventoryItems/GetInventoryItemsDDLList";
export const POST_GetInventoryItemStockDDLListByID =
  "/api/InventoryItems/GetInventoryItemStockDDLListByID";
export const POST_GetItemTypeDDLList = "/api/InventoryItems/GetItemTypeDDLList";

//Inventory Item Stock
export const POST_GetInventoryItemStockList =
  "/api/InventoryItemStock/GetInventoryItemStockList";
export const POST_InventoryItemStockExport =
  "/api/InventoryItemStock/InventoryItemStockExport";
export const POST_InventoryItemStockDelete =
  "/api/InventoryItemStock/InventoryItemStockDelete";
export const POST_GetInventoryItemStockDetailByID =
  "/api/InventoryItemStock/GetInventoryItemStockDetailByID";
export const POST_InventoryItemStockInsert =
  "/api/InventoryItemStock/InventoryItemStockInsert";
export const POST_InventoryItemStockUpdate =
  "/api/InventoryItemStock/InventoryItemStockUpdate";

//Inventory Item Issue
export const POST_GetInventoryItemIssueList =
  "/api/InventoryItemIssue/GetInventoryItemIssueList";
export const POST_InventoryItemIssueDelete =
  "/api/InventoryItemIssue/InventoryItemIssueDelete";
export const POST_InventoryItemIssueInsert =
  "/api/InventoryItemIssue/InventoryItemIssueInsert";
export const POST_GetInventoryItemIssueDDLListByID =
  "/api/InventoryItemIssue/GetInventoryItemIssueDDLListByID";
export const POST_GetInventoryItemReturnList =
  "/api/InventoryItemIssue/GetInventoryItemReturnList";
export const POST_InventoryItemReturnDelete =
  "/api/InventoryItemIssue/InventoryItemReturnDelete";
export const POST_InventoryItemReturnInsert =
  "/api/InventoryItemIssue/InventoryItemReturnInsert";

// Films
export const POST_GetFilmsList = "/api/Films/GetFilmsList";
export const POST_GetFilmsDetailByID = "/api/Films/GetFilmsDetailByID";
export const POST_FilmsExport = "/api/Films/FilmsExport";
export const POST_FilmsActiveInActive = "/api/Films/FilmsActiveInActive";
export const POST_FilmsDelete = "/api/Films/FilmsDelete";
export const POST_FilmsInsert = "/api/Films/FilmsInsert";
export const POST_FilmsUpdate = "/api/Films/FilmsUpdate";

// NDTCategory
export const GET_GetNDTCategoryTypes = "/api/NDTCategory/GetNDTCategoryTypes";
export const POST_GetNDTCategoryListByCategoryType =
  "/api/NDTCategory/GetNDTCategoryListByCategoryType";
export const POST_NDTCategoryExport = "/api/NDTCategory/NDTCategoryExport";
export const POST_NDTCategoryInsert = "/api/NDTCategory/NDTCategoryInsert";
export const POST_NDTCategoryDelete = "/api/NDTCategory/NDTCategoryDelete";
export const POST_NDTCategoryStatusUpdate =
  "/api/NDTCategory/NDTCategoryStatusUpdate";
export const POST_GetNDTCategoryByID = "/api/NDTCategory/GetNDTCategoryByID";
export const POST_NDTCategoryUpdate = "/api/NDTCategory/NDTCategoryUpdate";

// Camera
export const POST_GetCameraList = "/api/Camera/GetCameraList";
export const POST_CameraActiveInActive = "/api/Camera/CameraActiveInActive";
export const POST_CameraDelete = "/api/Camera/CameraDelete";
export const POST_CameraExport = "/api/Camera/CameraExport";
export const POST_GetCameraDetailByID = "/api/Camera/GetCameraDetailByID";
export const POST_CameraInsert = "/api/Camera/CameraInsert";
export const POST_CameraUpdate = "/api/Camera/CameraUpdate";
export const POST_GetCameraDropDownListByCompanyID =
  "/api/Camera/GetCameraDropDownListByCompanyID";
export const POST_GetNDTCategoryDropDownListByCategoryType =
  "/api/NDTCategory/GetNDTCategoryDropDownListByCategoryType";

// Supplier
export const POST_GetSupplierList = "/api/Supplier/GetSupplierList";
export const POST_SupplierActiveInActive =
  "/api/Supplier/SupplierActiveInActive";
export const POST_SupplierDelete = "/api/Supplier/SupplierDelete";
export const POST_GetSupplierDetailByID = "/api/Supplier/GetSupplierDetailByID";
export const POST_SupplierInsert = "/api/Supplier/SupplierInsert";
export const POST_SupplierUpdate = "/api/Supplier/SupplierUpdate";
export const POST_SupplierExport = "/api/Supplier/SupplierExport";
export const POST_GetSupplierDDLList = "/api/Supplier/GetSupplierDDLList";
export const POST_GetSupplierDDLListAJAX =
  "/api/Supplier/GetSupplierDDLListAJAX";

// GRN
export const POST_GetInventoryGRNList = "/api/InventoryGRN/GetInventoryGRNList";
export const POST_InventoryGRNExport = "/api/InventoryGRN/InventoryGRNExport";
export const POST_InventoryGRNDelete = "/api/InventoryGRN/InventoryGRNDelete";
export const POST_SupplierActiveInAct11ive =
  "/api/Supplier/SupplierActiveInActive";
export const POST_GetInventoryGRNDetailByID =
  "/api/InventoryGRN/GetInventoryGRNDetailByID";
export const POST_InventoryGRNInsert = "/api/InventoryGRN/InventoryGRNInsert";
export const POST_InventoryGRNUpdate = "/api/InventoryGRN/InventoryGRNUpdate";
export const POST_GetInventoryGRNPrintHTMLContents =
  "/api/InventoryGRN/GetInventoryGRNPrintHTMLContents";

// ItemWastage
export const POST_GetItemWastageList = "/api/ItemWastage/GetItemWastageList";
export const POST_GetItemWastageDetailByID =
  "/api/ItemWastage/GetItemWastageDetailByID";
export const POST_ItemWastageDelete = "/api/ItemWastage/ItemWastageDelete";
export const POST_ItemWastageInsert = "/api/ItemWastage/ItemWastageInsert";
export const POST_ItemWastageUpdate = "/api/ItemWastage/ItemWastageUpdate";
export const POST_ItemWastageExport = "/api/ItemWastage/ItemWastageExport";

// ItemDC
export const POST_GetItemDCList = "/api/ItemDC/GetItemDCList";
export const POST_GetItemIssueListByEmployeeID =
  "/api/ItemDC/GetItemIssueListByEmployeeID";
export const POST_ItemDCDelete = "/api/ItemDC/ItemDCDelete";
export const POST_GetItemDCInwardNoList = "/api/ItemDC/GetItemDCInwardNoList";
export const POST_GetItemDCDetailByID = "/api/ItemDC/GetItemDCDetailByID";
export const POST_ItemDCInsert = "/api/ItemDC/ItemDCInsert";
export const POST_ItemDCUpdate = "/api/ItemDC/ItemDCUpdate";
export const POST_GetItemDCPrintHTMLContents =
  "/api/ItemDC/GetItemDCPrintHTMLContents";

//Sample Preparation & Testing
export const POST_SamplePreparationAndTestingInsert =
  "/api/MaterialInward/SamplePreparationAndTestingInsert";
export const POST_SamplePreparationAndTestingFilesSave =
  "/api/MaterialInward/SamplePreparationAndTestingFilesSave";
export const POST_GetSamplePreparationAndTestingDetail =
  "/api/MaterialInward/GetSamplePreparationAndTestingDetail";
export const POST_SamplePreparationAndTestingUpdate =
  "/api/MaterialInward/SamplePreparationAndTestingUpdate";

//Inventory Reports
export const POST_GetItemStockRegisterList =
  "/api/InventoryReports/GetItemStockRegisterList";
export const POST_GetItemStockRegisterExport =
  "/api/InventoryReports/GetItemStockRegisterExport";
export const POST_GetItemIssueInOutList =
  "/api/InventoryReports/GetItemIssueInOutList";
export const POST_GetItemIssueInOutRegisterExport =
  "/api/InventoryReports/GetItemIssueInOutRegisterExport";

// MPT Material
export const POST_GetMPTMaterialList = "/api/MPTMaterial/GetMPTMaterialList";
export const POST_MPTMaterialActiveInActive =
  "/api/MPTMaterial/MPTMaterialActiveInActive";
export const POST_MPTMaterialDelete = "/api/NMPTMaterial/MPTMaterialDelete";
export const POST_MPTMaterialExport = "/api/MPTMaterial/MPTMaterialExport";
export const POST_GetMPTMaterialDetailByID =
  "/api/MPTMaterial/GetMPTMaterialDetailByID";
export const POST_MPTMaterialInsert = "/api/MPTMaterial/MPTMaterialInsert";
export const POST_MPTMaterialUpdate = "/api/MPTMaterial/MPTMaterialUpdate";
export const POST_GetMPTMaterialDropDownListByCompanyID =
  "/api/MPTMaterial/GetMPTMaterialDropDownListByCompanyID";

//Testing NDT
export const POST_GetTestingUTDetailByID =
  "/api/TestingNDT/GetTestingUTDetailByID";
export const POST_GetTestingRTDetailByID =
  "/api/TestingNDT/GetTestingRTDetailByID";
export const POST_GetTestingMTDetailByID =
  "/api/TestingNDT/GetTestingMTDetailByID";
export const POST_GetTestingPTDetailByID =
  "/api/TestingNDT/GetTestingPTDetailByID";
export const POST_TestingsUTSave = "/api/TestingNDT/TestingsUTSave";
export const POST_TestingsRTSave = "/api/TestingNDT/TestingsRTSave";
export const POST_TestingsMTSave = "/api/TestingNDT/TestingsMTSave";
export const POST_TestingsPTSave = "/api/TestingNDT/TestingsPTSave";
export const POST_TestingsNDTFilesSave = "/api/TestingNDT/TestingsNDTFilesSave";
export const POST_GetTestingsNDTApprovalDetailByID =
  "/api/TestingNDT/GetTestingsNDTApprovalDetailByID";

//Inward NDT
export const POST_GetMaterialInwardNDTDetail =
  "/api/MaterialInwardNDT/GetMaterialInwardNDTDetail";
export const POST_MaterialInwardNDTInsert =
  "/api/MaterialInwardNDT/MaterialInwardNDTInsert";
export const POST_MaterialInwardNDTFilesSave =
  "/api/MaterialInwardNDT/MaterialInwardNDTFilesSave";
export const POST_MaterialInwardNDTUpdate =
  "/api/MaterialInwardNDT/MaterialInwardNDTUpdate";
export const POST_MaterialInwardNDTHeaderDetailChange =
  "/api/MaterialInwardNDT/MaterialInwardNDTHeaderDetailChange";
